import { LOCAL_STORAGE_TUNNEL_DATA_KEY } from "../../../core/service/BusinessLogicService"
import { useQuery } from "react-query"
import { useLocalStorage } from "react-use"
import { apigateway } from "../../../intances/apigateway"

export default function useGetDeliveryMethodsByOrder(order) {
  const [localTunnelData] = useLocalStorage(LOCAL_STORAGE_TUNNEL_DATA_KEY)

  const { data: deliveryMethods, isLoading: isLoadingDeliveryMethods } = useQuery({
    queryKey: ["query-get-delivery-methods", order],
    queryFn: () => {
      const url = `/middle-business-service/api/v1/parameters/find-delivery-methods-by-country-code/${order?.supplierId}?countryCode=${order?.orderLanguageTag.split("-")[1]}`

      const deliveryMethods = apigateway(localTunnelData).get(url)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          console.error(error)
        })
      return deliveryMethods
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!order
  })

  return { deliveryMethods, isLoadingDeliveryMethods }
}
